module.exports = __webpack_public_path__ + "static/media/festival.0261839d.jpg";